import { Bucket } from "./types";

const numbers = new Intl.NumberFormat();

export function formatNumber(n: number | null | undefined): string {
  return n === null || n === undefined ? "n/a" : numbers.format(Math.round(n * 100) / 100);
}

export function formatPercent(rate: number | null | undefined): string {
  return rate === null || rate === undefined ? "n/a" : `${(rate * 100).toFixed(1)}%`;
}

export function formatDuration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return "n/a";
  if (seconds < 60) return `${Math.round(seconds)}s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}m`;
  return `${(seconds / 3600).toFixed(1)}h`;
}

export function change(value: number, previous: number): { text: string; direction: "up" | "down" | "flat" } {
  if (previous === 0) return value === 0 ? { text: "0%", direction: "flat" } : { text: "new", direction: "up" };
  const pct = Math.round(((value - previous) / previous) * 100);
  if (pct === 0) return { text: "0%", direction: "flat" };
  return { text: `${pct > 0 ? "+" : ""}${pct}%`, direction: pct > 0 ? "up" : "down" };
}

export function bucketLabel(t: string, bucket: Bucket): string {
  const d = new Date(t);
  return bucket === "hour"
    ? d.toLocaleString([], { weekday: "short", hour: "numeric" })
    : d.toLocaleDateString([], { month: "short", day: "numeric" });
}

export const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
